import BaseClient from './BaseClient';

class PromotionsClient extends BaseClient {
    getAll(teamId, params) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/promotions`, 'get', null, params);
    }

    getPromotion(teamId, promotionId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/promotions/${promotionId}`);
    }

    getPromotionCouponsStatistics(teamId, promotionId) {
        return this.makeCoreApiRequest(
            `/api/v3/teams/${teamId}/promotions/${promotionId}/promotion-coupons/statistics`,
            'get'
        );
    }

    savePromotion(teamId, promotionId, form) {
        return promotionId
            ? this.makeCoreApiRequest(`/api/v3/teams/${teamId}/promotions/${promotionId}`, 'put', form)
            : this.makeCoreApiRequest(`/api/v3/teams/${teamId}/promotions`, 'post', form);
    }

    deletePromotion(teamId, promotionId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/promotions/${promotionId}`, 'delete');
    }
}

export default new PromotionsClient();
